import { array, struct } from 'io-ts/Decoder';

import { Id as TakeOffId } from '../../../../whole-house/take-off/Id';

export const Request = struct({
	takeOffIds: array(TakeOffId),
});
